module.exports = __webpack_public_path__ + "static/media/4-how-to.5a9bc094.png";